<template>
  <div>
    <div class="main">
      <img src="../assets/tanninalertfunding.jpg" alt="Funding Partner Logos" />
    </div>
    <p>
      <strong>TanninAlert</strong> is an online tannin-monitoring portal providing customized
      data retrieval and tracking tools that facilitate best tannin management practices and
      informed decision-making throughout the winemaking process.
    </p>
    <p>
      Established in 2013, TanninAlert is a program developed specifically for Niagara that
      tracks and monitors grape skin and seed tannin concentrations in Niagara’s wine region
      to provide a historical database of tannin development during the harvest season.
      Current industry standard ripeness parameters measure sugar level (°Brix), pH, and
      acidity, to assess desirable qualities in wine, but they do not account for the extractable
      skin and seed tannin concentration measurements that are critical for red wine quality.
    </p>
    <p>
      In collaboration with lead researchers Dr. Debbie Inglis and Dr. Belinda Kemp from the
      Cool Climate Oenology and Viticulture Institute (CCOVI), OGWRI utilizes the data
      collected through the TanninAlert program to design a comprehensive, commercial
      solution to the balance of tannins and thereby enhance the quality of Ontario’s red wine.
    </p>
    <p>
      TanninAlert provides Canada’s first secure, online ripeness monitoring portal for grape
      growers and winemakers. Grape growers and winemakers can access relevant grape
      compositional data and corresponding tannin concentrations. These are grouped
      according to low, medium or high skin and seed tannin, which are categorized each year
      from historical data. Red winemaking recommendations for managing tannin during
      winemaking production is provided from published studies and research conducted at
      CCOVI research winery and laboratory focused solely on Niagara grape composition.
    </p>
  </div>
</template>

<script>
export default {
  name: 'Overview',
};
</script>

<style lang="scss" scoped>
  @import "../assets/_globals.scss";
  @import "../assets/_colors.scss";
  .img-caption {
    font-size: 12px;
    border-bottom: 1px solid #DDD;
    padding-bottom: 5px;
    margin-bottom: 5px;
  }
  .main {
    width: 500px;
    float: right;
  }
  @media screen and (max-width: $break-medium) {
    .main {
      width: 300px;
    }
  }
  @media screen and (max-width: $break-small) {
    .main {
      width: 100%;
      float: inherit;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Overview.vue